export { default } from "./useAssignmentActivitySelectionUpdate";
